import React from 'react';
import { Users, Target, Calendar, MapPin, Award } from 'lucide-react';
import './sobre.css';

export default function SobrePage() {
  return (
    <div className="sobre-page">
      {/* Header */}
      <section className="page-header">
        <div className="container">
          <div className="page-header-conteudo">
            <div className="secao-tag">Institucional</div>
            <h1>Sobre a LICMAB</h1>
            <p>Liga Cultural de Marabá — fundada em 2015 por dançarinos e artistas de Marabá, Pará.</p>
          </div>
        </div>
      </section>

      {/* Missão */}
      <section className="sobre-missao">
        <div className="container">
          <div className="missao-grid">
            <div className="missao-card destaque">
              <Target size={32} />
              <h3>Missão</h3>
              <p>Organizar os grupos culturais da cidade e representar suas demandas junto ao poder público e privado, fortalecendo a construção dos trabalhos desenvolvidos ao longo de anos em Marabá.</p>
            </div>
            <div className="missao-card">
              <Award size={32} />
              <h3>Valores</h3>
              <p>Promoção integral da pessoa humana, consciência dos direitos e deveres do cidadão, harmonia, respeito, ética, paz e cidadania.</p>
            </div>
            <div className="missao-card">
              <Users size={32} />
              <h3>Inclusão</h3>
              <p>Combatemos a pobreza, a fome, toda forma de discriminação e preconceito, promovendo o desenvolvimento sustentável, social e econômico.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Objetivos */}
      <section className="sobre-objetivos">
        <div className="container">
          <h2 className="secao-titulo">Objetivos e Finalidades</h2>
          <div className="objetivos-lista">
            {[
              'Contribuir para a promoção integral da pessoa humana, despertando a consciência dos direitos e deveres do cidadão, em clima de harmonia e respeito',
              'Realizar estudos e levantamentos socioeconômicos da comunidade, incluindo saúde, saneamento básico, urbanização, ensino, transporte, esporte, lazer e recreação',
              'Implementar ações para melhoria de vida nas comunidades onde os grupos culturais estão inseridos, em promoção cultural e educacional',
              'Difundir a cultura, defender, preservar e conservar o meio ambiente, proteger o consumidor e o patrimônio artístico, estético, histórico, turístico e paisagístico',
              'Trabalhar em prol da inclusão social digital e tecnológica dos excluídos e em defesa dos direitos humanos',
              'Desenvolver e incentivar a realização de atividades culturais e sociais. Lutar pelo resgate da Cultura Junina, Folclore Brasileiro, Artes Cênicas e tradicionais',
              'Desenvolver atividades sociais: quadrilhas, bois bumbas e marcadores de Marabá',
            ].map((obj, i) => (
              <div key={i} className="objetivo-item">
                <span className="objetivo-num">{String(i + 1).padStart(2, '0')}</span>
                <p>{obj}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Histórico */}
      <section className="sobre-historico">
        <div className="container">
          <div className="historico-conteudo">
            <div>
              <div className="secao-tag">Nossa História</div>
              <h2 className="secao-titulo">Fundação em 2015</h2>
              <p>
                A Assembleia Geral Extraordinária para aprovação estatutária da Liga Cultural de Marabá — 
                LICMAB foi realizada em <strong>15 de outubro de 2015</strong>, às 19 horas, na Sede Provisória 
                em Nova Marabá.
              </p>
              <p>
                A assembleia foi convocada pela Comissão Provisória composta por dançarinos e artistas, 
                com pauta de aprovação do Estatuto Social e eleição da primeira Diretoria Executiva.
              </p>
              <p>
                O Estatuto Social foi aprovado por unanimidade e a primeira Diretoria Executiva foi eleita, 
                com <strong>Ademar Gomes Dias</strong> como Presidente fundador.
              </p>
            </div>
            <div className="historico-info">
              <div className="info-item">
                <Calendar size={20} />
                <div>
                  <strong>Fundação</strong>
                  <span>15 de outubro de 2015</span>
                </div>
              </div>
              <div className="info-item">
                <MapPin size={20} />
                <div>
                  <strong>Sede</strong>
                  <span>Folha 08 Qd 03 Lote 12, Nova Marabá, Pará</span>
                </div>
              </div>
              <div className="info-item">
                <Award size={20} />
                <div>
                  <strong>CNPJ</strong>
                  <span>24.603.962/0001-01</span>
                </div>
              </div>
              <div className="info-item">
                <Users size={20} />
                <div>
                  <strong>Natureza Jurídica</strong>
                  <span>Pessoa jurídica de direito privado, fins não econômicos</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Coordenações */}
      <section className="sobre-coordenacoes">
        <div className="container">
          <h2 className="secao-titulo" style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
            Áreas de Coordenação
          </h2>
          <div className="coord-grid">
            {[
              'Educação', 'Saúde', 'Cultura', 'Meio Ambiente',
              'Esporte e Lazer', 'Direitos Humanos', 'Habitação', 'Assuntos da Mulher',
            ].map(coord => (
              <div key={coord} className="coord-chip">
                <span>★</span> {coord}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
